import { BrokerActionType } from '../Constants';

// const isFeatureEnabled = (featureId, userState) => {
//     if (!userState || !userState.featureList) {
//         return false;
//     }
//     const feature = userState.featureList.find(
//         (f) => f.featureId === featureId
//     );
//     return feature?.isEnabled ?? false;
// };

export const getBrokerActions = (
    broker: {
        brokerId?: number | null;
        id?: number | null;
    },
    userState // eslint-disable-line
) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];

    if (broker.brokerId != null) {
        actions.push({
            actionId: BrokerActionType.ViewEditBroker,
            brokerId: broker.brokerId,
            text: 'View/Edit',
            stylingMode: 'contained',
        });
    } else {
        if (broker.id != null) {
            actions.push({
                actionId: BrokerActionType.DeleteIncompleteRegisteredBroker,
                userId: broker.id,
                text: 'Delete',
                stylingMode: 'contained',
            });
        }
    }

    if (broker.id != null) {
        actions.push({
            actionId: BrokerActionType.SendPasswordResetEmail,
            userId: broker.id,
            text: 'Password Reset',
            stylingMode: 'contained',
            disabled: false,
        });
    }

    return actions;
};
